namespace('compass.util');

(function(undefined) {
	function dateParser (src, format) {
		format = format || "YYYY-MM-DD";

		var delimiter = "/";
		var parts = src.split("/");
		if(parts.length === 1){
			parts = src.split("-");
			delimiter = "-";
		}
		if(parts.length > 1){
			src = '';
			_.each(parts, function(n) {
				if(n.length < 2){
					src += '0'+n;
				}else{
					src += n;
				}
				src += delimiter;
			});
			src = src.slice(0, -1);
		}

		var year = "", month = "", date = "";
		for (var i = 0, l = src.length; i < l; i++) {
			if (format[i] === 'Y' || format[i] === 'y') {
				year += src[i];
			} else if (format[i] === 'M' || format[i] === 'm') {
				month += src[i];
			} else if (format[i] === 'D' || format[i] === 'd') {
				date += src[i];
			}
		}

		if (year.length === 2)
			year = "20"+year;

		return new Date(
			parseInt(year, 10),
			parseInt(month, 10)-1, // JS months are 0 indexed
			parseInt(date, 10)
		);
	}

	function isDateInDateRange (dateToCheckString, rangeBeginString, rangeEndString){
		var dateToCheck = compass.util.parse.ISODateParser(dateToCheckString);
		var beginDate = compass.util.parse.ISODateParser(rangeBeginString);
		var endDate = compass.util.parse.ISODateParser(rangeEndString);
		if(dateToCheck >= beginDate && dateToCheck <= endDate)
			return true;
		else{
			return false;
		}
	}

	compass.util.parse = {
		DateParse: dateParser,
		ISODateParser: function (src) {
			return dateParser(src);
		},
		isDateInDateRange : isDateInDateRange
	};
}());
